import React, { useEffect, useRef, useState } from "react";
import MessageBox from "./MessageBox";
import styles from "../styles/MessageList/MessageList.module.css";
import Button from "./Button";
import { useAtom } from "jotai";
import {
  messageCountAtom,
  currentPageAtom,
  workOrderIDAtom,
  conversationsAtom,
  ticketAtom
} from "../store";
import useConversation from "../hooks/useConversation";
import { motion } from "framer-motion";

interface MessageListProps {
  messageBox: {
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  };
  messages: any[];
  isFetchingOlderConversations: boolean;
  setIsFetchingOlderConversations: React.Dispatch<
    React.SetStateAction<boolean>
  >;
}

const MessageList = ({
  messageBox,
  messages,
  isFetchingOlderConversations,
  setIsFetchingOlderConversations,
  ...rest
}: MessageListProps) => {
  const [workOrderID] = useAtom(workOrderIDAtom);
  const [count] = useAtom(messageCountAtom);
  const [ticketData, ] = useAtom(ticketAtom);

  const [page, setPage] = useAtom(currentPageAtom);
  const { fetchMessages } = useConversation({ count: count });
  const messageBoxRef = useRef<any>(null);

  return (
    <>
      <div className="older-convo-btn-box">
        {<div className="bold-text">Conversation</div>}
        {messages.length > 0 &&
          fetchMessages.totalMessageCount !== messages.length &&
          (isFetchingOlderConversations ? (
            "Loading..."
          ) : (
            <Button
              variant="link"
              onClick={() => {
                setPage((page) => (page += 1));
                setIsFetchingOlderConversations(true);
              }}
            >
              View Older Conversations
            </Button>
          ))}
      </div>
      <div>
        {fetchMessages.loading && !messages.length && (
          <div className={styles.loaderContainer}>
            <small>Loading...</small>
          </div>
        )}

        {!fetchMessages.loading && messages.length === 0 ? (
          !messageBox.open && (
            <div className={styles.noMessage}>
              <p>No conversations</p>
            </div>
          )
        ) : (
          <></>
        )}

        <div className="messages-overflow">
          {messages?.map((msg: any, index: any) => (
            <motion.div
              key={index}
              initial={{ scale: 0.95 }}
              whileInView={{ scale: 1 }}
              viewport={{ root: messageBoxRef, margin: "150px", once: true }}
              transition={{ duration: 0.4 }}
            >
              <MessageBox key={`key-${index}`} {...msg} />
            </motion.div>
          ))}
        </div>

        {!messageBox.open && ticketData && ticketData.is_closed == 0 && (
          <div className={styles.noMessage}>
            <Button onClick={() => messageBox.setOpen(true)}>
              Send a message
            </Button>
          </div>
        )}
      </div>
    </>
  );
};

export default MessageList;
